module.exports = __webpack_public_path__ + "static/media/ATVOBackground.974988c6.jpg";